module.exports = __webpack_public_path__ + "crm_static/img/img_businesslicense.0ff0eab4.png";